import React from "react";
import { Box, Typography } from "@mui/material";

interface GiftCardStatisticsProps {
  s: {
    totalGiftCards: number;
    totalSold: number;
    totalValueSpent: number;
    revenue: number;
    potentialRevenue: number;
    realizedProfit: number;
    potentialProfit: number;
  };
}

const toNum = (v: unknown) => (typeof v === "number" && Number.isFinite(v) ? v : Number(v ?? 0)) || 0;
const fmt = (n: unknown) => `$${toNum(n).toFixed(2)}`;

const GiftCardStatistics: React.FC<GiftCardStatisticsProps> = ({ s }) => {
  return (
    <Box mt={4}>
      <Typography variant="h6">Statistics</Typography>
      <Typography>Total Gift Cards: {s.totalGiftCards}</Typography>
      <Typography>Total Sold: {s.totalSold}</Typography>
      <Typography>Total Value spent: {fmt(s.totalValueSpent)}</Typography>
      <Typography>Total Revenue: {fmt(s.revenue)}</Typography>
      <Typography>
        Total Potential Revenue: {fmt(s.potentialRevenue)}
      </Typography>
      <Typography>Realized Profit: {fmt(s.realizedProfit)}</Typography>
      <Typography>Potential Profit: {fmt(s.potentialProfit)}</Typography>
    </Box>
  );
};

export default GiftCardStatistics;
